import script from "./datatableProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./datatableProfile.vue?vue&type=script&setup=true&lang=js"

import "./datatableProfile.vue?vue&type=style&index=0&id=211d95e1&lang=scss"

const __exports__ = script;

export default __exports__